import Cookies from 'universal-cookie'
const cookies = new Cookies()

export function logOut() {
  cookies.remove('access_nhansu_token', { path: '/' })
  cookies.remove('user_info', { path: '/' })
  window.location.href = '/login'
}

// get
export function getAccessToken() {
  return cookies.get('access_nhansu_token')
}

export function getUserInfo() {
  return cookies.get('user_info')
}

export function getProjectInfo() {
  return cookies.get('project_info')
}

export function getBranchInfo() {
  return cookies.get('branch_info')
} 

// set
export function saveAccessToken(value: string) {
  return cookies.set('access_nhansu_token', value, {
    path: '/',
  })
}


export function saveUserInfo(value: string) {
  return cookies.set('user_info', value, {
    path: '/',
  })
}

export function saveProjectInfo(value: string) {
  return cookies.set('project_info', value, {
    path: '/',
  })
}

export function saveBranchInfo(value: string) {
  return cookies.set('branch_info', value, {
    path: '/',
  })
}





export function isLoggedIn() {
  return !!getAccessToken()
}

